import * as React from 'react';
import { View, StyleSheet, useWindowDimensions } from 'react-native';
import Text from 'design-system/Text';
import { rem, Spacer } from 'design-system';
import CarouselCardInvest from 'login/firstscreen/carousel-cards/CarouselCardInvest';
const SecclInitialScreenTopInfo = () => {
    const { width } = useWindowDimensions();
    return (<>
      <View style={styles.contentContainer}>
        <CarouselCardInvest withShadow medium small={width <= 400}/>
      </View>
      <Spacer h={32}/>
      <View style={styles.infoContainer}>
        <Text Text-24 centered>
          Build your portfolio
        </Text>
        <Spacer h={8}/>
        <Text TextThin-16 centered Secondary>
          {'Invest in globally diversified ETFs and\nfunds. Capital at Risk.'}
        </Text>
        <Spacer h={16}/>
      </View>
    </>);
};
export default React.memo(SecclInitialScreenTopInfo);
const styles = StyleSheet.create({
    contentContainer: {
        paddingTop: rem(24),
        alignItems: 'center',
        justifyContent: 'center',
    },
    infoContainer: {
        justifyContent: 'center',
        paddingHorizontal: rem(16),
    },
});
